import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNPatient } from 'src/app/models/cnpatient';
import { Eid } from 'src/app/models/eid';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-patient-dialog',
  templateUrl: './patient-dialog.component.html',
  styleUrls: ['./patient-dialog.component.scss']
})
export class PatientDialogComponent implements OnInit {

  public displaymode = 'full';
  public patient: CNPatient;
  public cardinfo: Eid;

  constructor(private dialogRef: MatDialogRef<PatientDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              public patientSrv: PatientService) {
                this.patient = (typeof data.patient !== 'undefined') ? data.patient : this.patientSrv.patient;
                this.cardinfo = (typeof data.cardinfo !== 'undefined') ? data.cardinfo : undefined;
              }

  ngOnInit(): void {
  }

  close(code: string) {
    this.dialogRef.close(code);
  }
}
